import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconNumber7Square: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconNumber7Square"><Path d="M20.5 3.5H3.5V20.5H20.5V3.5Z" stroke="currentColor"/><Path d="M9.88281 16.25L13.6797 8.82031V8.73828H9.15625V7.79492H14.752V8.77344L10.9902 16.25H9.88281Z" fill="currentColor"/></CentralIconBase>;
});

export default IconNumber7Square;
